// Package Imports
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-close',
  templateUrl: './portal-close.component.html',
  styleUrls: ['./portal-close.component.css']
})
export class PortalCloseComponent implements OnInit {
  constructor() { }

  ngOnInit() {
    window.close();
  }
}
